module.exports = __webpack_public_path__ + "static/media/wavm8s-027-kuiasu.963b5fa.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-027-kuiasu.mp3
// module id = VtwU
// module chunks = 0